import {getOutlet, hasOutlet} from 'reconnect.js';

export const PredefinedRoute = {
  profile: '/profile',
  checkout: '/checkout',
  checkoutInfo: '/checkout/info',
  mobileCheckoutInfo: '/mobile/checkout/info',
  checkoutReview: '/checkout/review',
  mobileCheckoutReview: '/mobile/checkout/review',
  products: '/products',
};

function parseUrl(input) {
  const [url, rawQuery = ''] = String(input).split('?');
  const query = {};
  const params = new URLSearchParams(rawQuery);
  params.forEach((value, key) => {
    query[key] = value;
  });
  return {url, query};
}

function buildUrl(url, params) {
  const search = new URLSearchParams();
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      search.set(key, String(value));
    }
  });
  const query = search.toString();
  return query ? `${url}?${query}` : url;
}

class NavUrl {
  static from(predefinedRoute, params = {}) {
    if (hasOutlet('routes')) {
      const routeConfig = getOutlet('routes').getValue();
      const customRoute =
        typeof routeConfig?.getRoute === 'function'
          ? routeConfig.getRoute(predefinedRoute, params)
          : null;

      if (customRoute) {
        const parsed = parseUrl(customRoute);
        return new NavUrl(parsed.url, parsed.query);
      }
    }

    return new NavUrl(predefinedRoute, params);
  }

  constructor(baseUrl, params = {}) {
    this.baseUrl = baseUrl;
    this.params = params;
  }

  toString() {
    return buildUrl(this.baseUrl, this.params);
  }
}

export default NavUrl;
